/* eslint-disable no-unused-vars */
/**

* By Sam Ayoub info@ddkits.com

* Copyright: IST

* This component to auto build meta tags for reactJS

*/

import React, { useEffect } from 'react';

export default function MetaTags(props) {
  const metaTags = [
    { name: 'title', content: props.title },
    { name: 'description', content: props.description.substring(0, 250) },
    { name: 'keywords', content: props.keywords },
    { name: 'author', content: props.author },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:title', content: props.title },
    { property: 'og:image', content: props.image },
    { property: 'og:url', content: window.location.href },
    { property: 'og:type', content: props.type },
    { property: 'og:sitename', content: props.sitename },
    { property: 'og:description', content: props.description.substring(0, 250) },
    { name: 'twitter:title', content: props.title },
    { name: 'twitter:image', content: props.image },
    { name: 'twitter:url', content: window.location.href },
    { name: 'twitter:card', content: props.description.substring(0, 250) },
  ];

  // Inject Meta Tags

  // Inject Meta Tags

  useEffect(() => {
    // Now we sync out meta tags
    metaTags.map((m) => {
      var meta = document.createElement('meta');
      // Remove old tags and add new one
      if (m.name) {
        // meta.name = m.name;
        meta.setAttribute('name', m.name);
        document.querySelector(`meta[name='${m.name}']`)?.remove();
      }
      else {
        // meta.property = m.property;
        meta.setAttribute('property', m.property);
        document.querySelector(`meta[property='${m.property}']`)?.remove();
      }
      // meta.content = m.content;
      meta.setAttribute('content', m.content);
      // console.log(meta);
      document.head.appendChild(meta);
    });
   // fix link validation for the page
   const canonical = document.querySelector(`link[rel='canonical']`);
   if (canonical) {
     canonical.setAttribute('href', window.location.href);
   } else {
     const canonicalLink = document.createElement('link');
     canonicalLink.setAttribute('rel', 'canonical');
     canonicalLink.setAttribute('href', window.location.href);
     document.head.appendChild(canonicalLink);
   }
    // Add title first as #1
    if (document.querySelector(`title`)) {
      document.querySelector(`title`).innerHTML = `${props.sitename} | ${props.title}`.toString();
    } else {
      document.head.innerHTML += `
    <title>${props.sitename}| ${props.title}</title>
    `;
    }
  }, [window.location.href]);

  return;
}
